var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B51F1F",
    className: "fill",
    d: "M4.96411 40.995C4.97514 50.5321 8.77146 59.6748 15.5191 66.4146C22.2667 73.1544 31.4138 76.9402 40.9508 76.9402C50.4879 76.9402 59.635 73.1544 66.3826 66.4146C73.1302 59.6748 76.9265 50.5321 76.9375 40.995H4.96411Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E20613",
    className: "fill",
    d: "M54.4314 40.995C54.4185 58.6018 45.4496 73.2338 33.6162 76.3281C35.1377 76.7327 36.705 76.9397 38.2793 76.9441C38.5797 76.9441 38.8766 76.9252 39.1757 76.9089C39.4879 76.9264 39.8018 76.9441 40.1181 76.9441C54.1822 76.9441 65.5847 60.852 65.5998 40.995H54.4314Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 40.955C0.000667086 30.0939 4.31528 19.6777 11.9949 11.9974C19.6745 4.31713 30.0903 0.00161532 40.9514 0C51.8122 0.00190267 62.2275 4.31761 69.9066 11.9979C77.5857 19.6783 81.8998 30.0942 81.9 40.955C81.8991 51.8147 77.5845 62.2294 69.9053 69.9081C62.226 77.5868 51.8111 81.9006 40.9514 81.9007C30.0914 81.9007 19.6761 77.587 11.9964 69.9083C4.3167 62.2297 0.00151964 51.815 0 40.955ZM8.34118 40.955C8.3537 49.599 11.7937 57.8854 17.9069 63.9968C24.02 70.1082 32.3073 73.5459 40.9514 73.556C49.5953 73.5463 57.8825 70.1086 63.9954 63.997C70.1082 57.8855 73.5475 49.5989 73.5589 40.955C73.547 32.3102 70.1078 24.0229 63.9954 17.9097C57.8831 11.7966 49.5961 8.35645 40.9514 8.34348C32.3065 8.35682 24.0195 11.797 17.9067 17.91C11.794 24.023 8.35419 32.3101 8.34118 40.955Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1bcb8a73cc49f7645ebc8061f8e46392.svg";
export { ForwardRef as ReactComponent };